import React from 'react';
import Icon from "../Icon";
import FloatContainer from "../../Wrappers/FloatContainer";
import DropdownItem from "./DropdownItem";

const JobItem = (props) => {
  const {job} = props
  return (
    <div className="s-relative s-mr-8px s-cross-center nowrap">
      <p className="s-color-light-text small s-mb-0 s-mr-4px">{job}</p>
      <FloatContainer>
        <Icon svg="vertical-dots" className="flex-none cursor-pointer" size="0.9rem"/>
        <div className="float-container ed-grid rows-gap s-gap-1">
          <DropdownItem text="Editar" />
          <DropdownItem text="Eliminar" />
        </div>
      </FloatContainer>
    </div>
  );
};

export default JobItem;
